import { useQuery } from "urql"

import { ACTIVE_PRODUCT_STATUSES } from "../constants"

import { FULL_LIST_LIMIT } from "@/constants/common"
import type {
  Product,
  ProductSearchForAssociationQuery,
  ProductSearchForAssociationQueryVariables,
  ProductSortInput,
} from "@/graphql/codegen/graphql"
import { ProductSearchForAssociationDocument } from "@/graphql/codegen/graphql"

interface UseSearchProductsForAssociationReturn {
  products: Product[]
  isFetchingProducts: boolean
}

const useSearchProductsForAssociation = ({
  query,
  showInactive,
  sort,
}: {
  query: string
  showInactive: boolean
  sort?: ProductSortInput
}): UseSearchProductsForAssociationReturn => {
  const [{ data, fetching }] = useQuery<ProductSearchForAssociationQuery, ProductSearchForAssociationQueryVariables>({
    query: ProductSearchForAssociationDocument,
    variables: {
      input: {
        filter: {
          query,
          ...(!showInactive && { computedProductStatuses: ACTIVE_PRODUCT_STATUSES }),
        },
        offset: 0,
        limit: FULL_LIST_LIMIT,
        ...(sort && { sort }),
      },
    },
    pause: query.length < 2,
  })

  const products =
    data?.product?.list?.__typename === "ProductListSuccess" ? (data.product.list.products as Product[]) : []

  return { products, isFetchingProducts: fetching }
}

export default useSearchProductsForAssociation
